const downloadMSA = async file => {
  const pdfBytes = await fetch(file).then(res => res.arrayBuffer());
  const url = URL.createObjectURL(new Blob([pdfBytes], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `UPShow Order Form & MSA ${process.env.REACT_APP_MSA_TEMPLATE_VERSION}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export default downloadMSA;
